import { render, staticRenderFns } from "./addShipmentDoc.vue?vue&type=template&id=165bc8d3&scoped=true&"
import script from "./addShipmentDoc.vue?vue&type=script&lang=js&"
export * from "./addShipmentDoc.vue?vue&type=script&lang=js&"
import style0 from "./addShipmentDoc.vue?vue&type=style&index=0&id=165bc8d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165bc8d3",
  null
  
)

export default component.exports